import { Loading, Title } from "@components";

import StageDetails from "./StageDetails";
import LifeCycleInvoicing from "./LifeCycleInvoicing";
import LifeCycleStages from "./LifeCycleStages";
import StageTransitions from "./StageTransitions";
import StageBehavior from "./StageBehavior";
import { useEffect, useState } from "react";
import { ReportsAPI } from "providers/ReportsAPI";
import { getAllMonthsUntilNow } from "pages/Reports/Reports";
import { If } from "shared/components/control-statements";

export default function Index() {
  const months = getAllMonthsUntilNow(false);
  const [data, setData] = useState(null);
  const [selectedMonth] = useState(months[0]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const provider = new ReportsAPI();
      const response = await provider.lifeCycle(
        "stages",
        selectedMonth.year,
        selectedMonth.month
      );

      setData(response);
      setLoading(false);
    };

    fetchData();
  }, [selectedMonth]);

  return (
    <>
      <If cond={loading}>
        <Loading fullContent />
      </If>

      <Title
        title="Ciclo de Vida"
        backTo={{ url: "/relatorios/clientes", name: "Clientes" }}
      />

      <LifeCycleStages data={data} />
      <LifeCycleInvoicing />
      <StageDetails />
      <StageTransitions />
      <StageBehavior />
    </>
  );
}
